import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_CUSTOMER_LIST',
    url: '/api/customers',
    manual: false,
  });
  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/customers';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [data || [], exec, isRequestSuccessed];
});
